/* tslint:disable */
/* eslint-disable */
/**
 * Profile API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateProfileSkillRequest
 */
export interface UpdateProfileSkillRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdateProfileSkillRequest
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateProfileSkillRequest
     */
    type: UpdateProfileSkillRequestTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof UpdateProfileSkillRequest
     */
    origin?: UpdateProfileSkillRequestOriginEnum;
}


/**
 * @export
 */
export const UpdateProfileSkillRequestTypeEnum = {
    Functional: 'FUNCTIONAL',
    Global: 'GLOBAL'
} as const;
export type UpdateProfileSkillRequestTypeEnum = typeof UpdateProfileSkillRequestTypeEnum[keyof typeof UpdateProfileSkillRequestTypeEnum];

/**
 * @export
 */
export const UpdateProfileSkillRequestOriginEnum = {
    Manual: 'MANUAL',
    Suggestion: 'SUGGESTION'
} as const;
export type UpdateProfileSkillRequestOriginEnum = typeof UpdateProfileSkillRequestOriginEnum[keyof typeof UpdateProfileSkillRequestOriginEnum];


/**
 * Check if a given object implements the UpdateProfileSkillRequest interface.
 */
export function instanceOfUpdateProfileSkillRequest(value: object): value is UpdateProfileSkillRequest {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('type' in value) || value['type'] === undefined) return false;
    return true;
}

export function UpdateProfileSkillRequestFromJSON(json: any): UpdateProfileSkillRequest {
    return UpdateProfileSkillRequestFromJSONTyped(json, false);
}

export function UpdateProfileSkillRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateProfileSkillRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'type': json['type'],
        'origin': json['origin'] == null ? undefined : json['origin'],
    };
}

export function UpdateProfileSkillRequestToJSON(value?: UpdateProfileSkillRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'type': value['type'],
        'origin': value['origin'],
    };
}

